module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Kaffemuehle-QV.6b5b7b69.jpg";